import { useGetRolesQuery } from 'modulesCommon/graphql/queries/getRoles.types'
import { useMemo } from 'react'
import { Role } from 'shared/__gql-types'
import { TSelectOption } from 'shared/types'

export const useRoles = () => {
  const { data: rolesResponse, error, loading } = useGetRolesQuery()

  const rolesById = useMemo(
    () => (rolesResponse?.getRoles ?? []).reduce<Record<string, Role>>((roleById, role) => ({ ...roleById, [role?.id ?? '']: role }), {}),
    [rolesResponse?.getRoles],
  )

  const rolesOptions = useMemo(
    () =>
      (rolesResponse?.getRoles ?? []).map<TSelectOption>(
        (role) => ({
          label: role.name,
          value: role.id
        })
      ),
    [rolesResponse?.getRoles]
  )

  return {
    roles: rolesResponse?.getRoles ?? [],
    rolesOptions,
    rolesById,
    error,
    loading
  }
}
